import { actionType } from './action';
import { IAction } from '@interface/IAction';

export const InitialState = Object.freeze({
    accountSummary: {},
    txnRecords: [],
    depositWithdrawalRecords: [],
    contributions: [],
    awaitingRepaymentRecords: [],
    pastAuctions: []
});


const reducer = (preState = InitialState, action: IAction) => {
    const { type, payload } = action;

    switch (type) {

        case actionType.SET_ACCOUNT_BALANCE_SUMMARY:
            return {
                ...preState,
                accountSummary: payload
            };

        case actionType.SET_TRANSACTION_RECORDS:
            return {
                ...preState,
                txnRecords: payload
            };

        case actionType.SET_DEPOSIT_WITHDRAWAL_RECORDS:
            return {
                ...preState,
                depositWithdrawalRecords: payload
            };

        case actionType.SET_FUNDER_CONTRIBUTIONS:
            return {
                ...preState,
                contributions: payload
            };

        case actionType.SET_AWAITING_REPAYMENT_RECORDS:
            return {
                ...preState,
                awaitingRepaymentRecords: payload
            };

        case actionType.SET_PAST_AUCTIONS:
            return {
                ...preState,
                pastAuctions: payload
            }

        default:
            return preState;
    }
}

export default reducer;